import { FieldTypeLink } from '@allesauto/utils/consts';
import { getUrlFromStoryblokLink } from '@allesauto/utils/funcs';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React, { FC } from 'react';

import { AccordionFaqAdapter } from './AccordionFaqAdapter';
import FaqItem, { FaqItemProps } from './FaqItem';
import TextLink from '../textLink';

export { AccordionFaqAdapter };

export type AccordionFaqProps = {
  headline: string;
  subtext: string;
  accordionHeading?: string;
  link?: FieldTypeLink;
  linkLabel?: string;
  bgColor?: string;
  accordionItems: FaqItemProps[];
  onlyAccordion?: boolean;
  component: string;
  _uid: string;
  _editable?: string;
};

const AccordionFaq: FC<AccordionFaqProps> = (props: AccordionFaqProps) => {
  const {
    headline,
    subtext,
    linkLabel,
    link,
    accordionItems,
    bgColor,
    onlyAccordion = false,
  } = props;

  const backgroundColor = bgColor === 'grey' ? 'grey10' : 'white';

  const className = {
    container: clsx(
      `bg-${backgroundColor} grid grid-cols-24 lg:grid-rows-1 py-100px w-full grid-flow-row auto-rows-[minmax(0,_auto)] gap-y-30px lg:gap-y-0`
    ),
    containerFaq:
      'lg:col-end-9 lg:col-start-3 row-start-1 row-end-1 col-start-2 col-end-24 custom-class-grid min-h-[50px] auto-rows-min',
    containerText: clsx(
      'border-7px border-solid grid grid-cols-22 min-h-[14rem] lg:grid-cols-6 lg:min-h-[22.5rem]',
      'border-green60 wl-border-highlight monochrome:border-grey90'
    ),
    headline: clsx(
      `lg:-ml-60px mt-[-38px] md:-mt-60px pl-15px bg-${backgroundColor} lg:col-end-5 lg:col-start-1 col-start-2 col-end-17 font-headline lg:mt-60px text-headline1 lg:mb-30px`,
      'text-purple80 monochrome:text-grey90'
    ),
    subtext:
      'lg:col-end-6 lg:col-start-2 col-start-3 col-end-19 font-regular text-headline1S  text-grey100',
    textlink: `lg:col-start-2 lg:col-end-5 col-start-3 col-end-18 text-p1 border-red accordion-faq--custom-border__${backgroundColor} lg:mb-25px lg:mt-20px`,
  };

  return (
    <div {...sbEditable(props)} className={className.container}>
      {!onlyAccordion && (
        <div className={className.containerFaq}>
          <div className={className.containerText}>
            <h2 className={className.headline}>{headline}</h2>
            <p className={className.subtext}>{subtext}</p>
            {linkLabel && link && (
              <TextLink
                href={getUrlFromStoryblokLink(link)}
                target={link?.target ?? '_self'}
                text={linkLabel}
                customClassName={className.textlink}
              />
            )}
          </div>
        </div>
      )}
      {accordionItems?.map((item, key) => (
        <FaqItem {...item} key={key} onlyAccordion={onlyAccordion} />
      ))}
    </div>
  );
};

export default AccordionFaq;
